const MIN_SWIPE_DISTANCE = 50;

export const shouldCloseForSwipe = ({
  startX,
  startY,
  endX,
  endY,
  direction,
}) => {
  const deltaX = endX - startX;
  const deltaY = endY - startY;

  if (Math.abs(deltaX) <= Math.abs(deltaY)) {
    return false;
  }

  if (Math.abs(deltaX) < MIN_SWIPE_DISTANCE) {
    return false;
  }

  if (direction === 'left') {
    return deltaX < 0;
  }

  return deltaX > 0;
};

export const useMobileSwipeClose = ({ canTrack, onClose, direction }) => {
  let touchSession = null;

  const resetTouchSession = () => {
    touchSession = null;
  };

  const onTouchStart = event => {
    if (!canTrack?.() || event.touches?.length !== 1) {
      resetTouchSession();
      return;
    }

    touchSession = {
      startX: event.touches[0].clientX,
      startY: event.touches[0].clientY,
    };
  };

  const onTouchEnd = event => {
    if (!touchSession) {
      return false;
    }

    const touch = event.changedTouches?.[0];

    if (!touch) {
      resetTouchSession();
      return false;
    }

    const shouldClose = shouldCloseForSwipe({
      ...touchSession,
      endX: touch.clientX,
      endY: touch.clientY,
      direction,
    });

    resetTouchSession();

    if (shouldClose) {
      onClose?.();
      return true;
    }

    return false;
  };

  return {
    onTouchStart,
    onTouchEnd,
    resetTouchSession,
  };
};
